/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: hooks.ts
 * Project: mle-client-n
 * Committed last: 2022/6/9 @ 1049
 * ---
 * Description:
 */

import {Dialog, Toggle} from "./props";
import {useState} from "react";

/**
 * Effettua una richiesta web in modo sicuro, assicurandosi che non lanci eccezioni. Nel caso di errori, vengono resituiti
 * come risultato della promise, ma non vengono 'lanciati'.
 * @param req Funzione asincrona che effettui la richiesta
 * @param logErr Indica se loggare in console l'errore o meno
 * @param onErr Funzione da chiamare in caso di errori
 */
export const safeRequest = async <T>(req: () => Promise<T>, onErr?: (e: Error) => Promise<void>, logErr?: boolean): Promise<T | Error> => {
  try {
    return await req();
  } catch (e) {
    if (logErr === true)
      console.error(e);

    if (onErr)
      await onErr(e);

    return e;
  }
};


/**
 * Hook to encapsulate the working logic of a Dialog state handling
 */
export const useDialog = (): Dialog => {
  const [isVisible, setIsVisible] = useState(false);

  return {
    show() {
      setIsVisible(true);
    },

    hide() {
      setIsVisible(false);
    },

    toggle(val: boolean) {
      setIsVisible(val)
    },

    isVisible() {
      return isVisible
    }
  }
}

/**
 * Hook per semplificare l'uso di toggle
 */
export const useToggle = (): Toggle => {
  const [state, setState] = useState(false);

  return {
    toggle(): boolean {
      setState(!state)

      return !state
    },

    isTrue(): boolean {
      return state
    },

    isFalse(): boolean {
      return !state;
    },

    value(): boolean {
      return state;
    }
  }
}